import React, { useState } from "react";
import { Tabs } from "antd";

import WorkOrderTab from "./WorkOrderTab";
import WorkOrderHistoryTab from "./WorkOrderHistoryTab";

const AssignedToMe = () => {
  const [activeTab, setActiveTab] = useState("1");

  return (
    <div className="white-container" style={{ padding: "10px" }}>
      <div className="row" style={{ padding: "10px", marginBottom: "10px" }}>
        <div className="col-12">
          <div className="theme-content-title text-left">
            <h3 style={{ margin: 0 }}>Assigned To Me</h3>
          </div>
        </div>
      </div>

      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Work Orders" key="1">
          <WorkOrderTab assignedToMe={true} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Work Order History" key="2">
          <WorkOrderHistoryTab assignedToMe={true} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default AssignedToMe;
